import { render, staticRenderFns } from "./Route.vue?vue&type=template&id=07cc956c&scoped=true"
import script from "./Route.js?vue&type=script&lang=js&external"
export * from "./Route.js?vue&type=script&lang=js&external"
import style0 from "./Route.scss?vue&type=style&index=0&id=07cc956c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cc956c",
  null
  
)

export default component.exports